import Vue from "vue"

export const documentFileStore = {
  state: {
    documentFile: {},
    documentFiles: [],
  },
  mutations: {
    SET_DOCUMENT_FILE_PROPERTY(state, { key, value }) {
      Vue.set(state.documentFile, key, value)
    },
    SET_DOCUMENT_FILE(state, documentFile) {
      Vue.set(state, 'documentFile', documentFile)
    },
    SET_DOCUMENT_FILES(state, documentFiles) {
      Vue.set(state, 'documentFiles', documentFiles)
    },
  },
  actions: {
    deleteDocumentFile({ commit }, documentFileId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/document_files/${documentFileId}`).then(data => {
          if (data.ok) {
            resolve(data)
          }
        })
      })
    }
  },
  getters: {
    getDocumentFileDeletedAt: (state) => (index) => {
      return Vue.prototype
        .$dayjs(state.documentFiles[index].deleted_at)
        .format('DD.MM.YYYY H:mm')
    }
  }
}